export default __webpack_public_path__ + "static/media/Gosebrink.74ec15b4.png";